import '.h{display:flex;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'
import { Style, styled } from 'inlines'
import { ReactNode } from 'react'
import { useTranslations } from '@i18n/useLanguage'
import { useInfiniteScroll } from '@app/util/useInfiniteScroll'
import { pluralize } from '@i18n/localizeHelper'
import { Text } from '@app/components/core/typography/Text'
import { SearchTitle } from './SearchTitle'
import useMediaQuery from '@app/util/useMediaQuery'

export type SearchGridProps = {
  items: ReactNode[]
  totalItems: number
  title: string
  subtitle: string
  searchTerm?: string
  isLoading: boolean
  gridStyle: Style
  loadMore: () => void
  onResetSearch: () => void
}

export const SearchGrid = ({
  items,
  totalItems,
  title,
  subtitle,
  searchTerm,
  isLoading,
  gridStyle,
  loadMore,
  onResetSearch,
}: SearchGridProps) => {
  const isMobile = useMediaQuery()
  const { lastItemRef } = useInfiniteScroll({
    isLoading,
    hasMore: items.length < totalItems,
    loadMore,
    itemCount: items.length,
  })

  const translations = useTranslations().app.discoveryPage
  const appliedGridStyle: Style = isMobile
    ? {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }
    : gridStyle

  return (
    <Column alignItems="stretch" style={{ flexGrow: 0 }}>
      <Column alignItems="stretch" gap={isMobile ? '0.5rem' : '1rem'}>
        <Title.H3 style={{ alignSelf: 'start' }}>
          <SearchTitle
            title={title}
            searchTerm={searchTerm}
            onClick={onResetSearch}
          />
        </Title.H3>
        <Text.Medium>
          {searchTerm
            ? pluralize(translations.searchResults, totalItems)
            : subtitle}
        </Text.Medium>
      </Column>
      <styled.div style={appliedGridStyle}>
        {items &&
          items.map((item, index) => {
            if (items.length === index + 1) {
              return (
                <span className="h"
                  key={index}
                  ref={lastItemRef}
                >
                  {item}
                </span>
              )
            }
            return (
              <span className="h"
                key={index}
              >
                {item}
              </span>
            )
          })}
      </styled.div>
    </Column>
  )
}
